import 'styled-components/macro';
import Tooltip from '../Tooltip';
import { StyledInputIcon } from './InputIcon.styles';

function InputIcon({ prefix, invalid, suffix, children, disabled, tooltip, ...props }) {
  return (
    <StyledInputIcon $prefix={prefix} $invalid={invalid} $suffix={suffix} disabled={disabled} {...props}>
      {tooltip ? <Tooltip title={tooltip}>{children}</Tooltip> : children}
    </StyledInputIcon>
  );
}

export default InputIcon;
